import React from "react";

export const VIDEO = ({
  src,
  style,
}: {
  src?: string;
  style: {
    height?: string | number;
    width?: string | number;
    margin?: any[];
    borderRadius?: number | string;
  };
}) => (
  <video
    style={{
      borderRadius: `${style?.borderRadius}px`,
      margin: `${style?.margin?.[0]}px ${style?.margin?.[1]}px ${style?.margin?.[2]}px ${style?.margin?.[3]}px`,
      height: isNaN(Number(style?.height)) ? style?.height : `${style?.height}px`,
      width: isNaN(Number(style?.width)) ? style?.width : `${style?.width}px`,
    }}
    src={src}
  >
    <source src={src} type="video/mp4" />
    <source src={src} type="video/ogg" />
  </video>
);
